module.exports = __webpack_public_path__ + "static/img/t20.9430792e.png";